/* import __COLOCATED_TEMPLATE__ from './task-review.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { type SampleApiDoc } from 'embercom/components/reporting/automation/ai-insights/optimize-suggestions/suggestions/suggestion-accordion-items/suggestion-sample-api-item';
import type TaskSuggestion from 'embercom/models/content-service/task-suggestion';
import type { OptimizeSuggestionItem } from 'embercom/services/optimize-suggestions-service';

interface Signature {
  Args: {
    taskSuggestion: OptimizeSuggestionItem;
  };
}

export default class TaskReview extends Component<Signature> {
  @service declare intl: IntlService;

  @tracked openSectionId: string | null = '1';
  @tracked showSidePanel = true;
  @tracked openSidebarSection: string | null = 'context';

  get taskSuggestion(): TaskSuggestion {
    return this.args.taskSuggestion.suggestion as TaskSuggestion;
  }

  get topicsString(): string {
    if (!this.args.taskSuggestion.topicList || this.args.taskSuggestion.topicList.length === 0) {
      return '';
    }
    return this.args.taskSuggestion.topicList.join(', ');
  }

  // TODO: Replace with real conversation data from API
  get sampleConversations() {
    /* eslint-disable @intercom/intercom/no-bare-strings */
    let sampleNames = [
      {
        name: 'Kostas Tserolas',
        initials: 'KT',
        preview: "Why are my emails not hitting the 'New Buy...",
      },
      {
        name: 'Nitin Ranka',
        initials: 'NR',
        preview: 'How can I change or remove the phone nu...',
      },
      {
        name: 'Rintol Subash',
        initials: 'RS',
        preview: "Why is my 'Route customer conversations t...",
      },
      {
        name: 'Hannah Nees',
        initials: 'HN',
        preview: 'Is the issue with our main messenger workf...',
      },
    ];

    return this.taskSuggestion.sampledConversationIds
      .slice(0, 4)
      .map((id: string, index: number) => ({
        id,
        ...sampleNames[index % sampleNames.length],
        time: '4 mo',
      }));
  }

  get buildSampleApiDoc(): SampleApiDoc {
    return {
      requestMethod: this.taskSuggestion.actionMethod,
      requestUrl: this.taskSuggestion.actionPath,
      requestBody: this.taskSuggestion.actionParams,
      responseBody: this.taskSuggestion.mockResponse,
    } as SampleApiDoc;
  }

  @action
  onOpenSectionChange(sectionId: string): void {
    this.openSectionId = sectionId;
  }

  @action
  toggleSidePanel(): void {
    this.showSidePanel = !this.showSidePanel;
  }

  @action
  toggleSidebarSection(sectionId: string): void {
    this.openSidebarSection = this.openSidebarSection === sectionId ? null : sectionId;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::TaskReview': typeof TaskReview;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/task-review': typeof TaskReview;
  }
}
